import React from "react";

import Text from "components/common/Text";

export default function SummaryHeader({fromSummary}) {
  return fromSummary ? <Text variant="variant13" element="div" label="summary.sidebar.header"/> : null;
}
